import { render } from "./HistoricoLicenca.vue?vue&type=template&id=6d920697&scoped=true"
import script from "./HistoricoLicenca.vue?vue&type=script&lang=ts"
export * from "./HistoricoLicenca.vue?vue&type=script&lang=ts"

import "./HistoricoLicenca.vue?vue&type=style&index=0&id=6d920697&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6d920697"

export default script